<template>
  <div class="appDetails">
    <van-panel
      title="内镜"
      v-if="neijingInfo.id"
    >
      <div class="appDetails-content">
        <p>
          预约日期：{{ neijingInfo.bookingTime }}
        </p>
        <p>
          预约状态：{{ neijingInfo.his_booking_status | bookStatus }}
        </p>
        <p>
          套餐名称：{{ neijingInfo.his_package_name }}
        </p>
        <p>
          备注内容：{{ neijingInfo.pay_remark }}
        </p>
      </div>
    </van-panel>
    <van-panel
      title="体检"
      v-if="tijianInfo.id"
    >
      <div class="appDetails-content">
        <p>
          预约日期：{{ tijianInfo.bookingTime }}
        </p>
        <p>
          预约状态：{{ neijingInfo.tijian_his_booking_status | bookStatus }}
        </p>
        <p>
          套餐名称：{{ tijianInfo.tijian_package_name }}
        </p>
        <p>
          备注内容：{{ tijianInfo.tijian_package_remark }}
        </p>
      </div>
    </van-panel>
  </div>
</template>

<script>
import menZhenService from "@/apis/menZhen/index.js";
import moment from "moment";

export default {
  filters: {
    bookStatus(status) {
      const evelMap = {
        0: "待预约",
        1: "已预约",
        2: "已完成",
        3: "已取消",
      };
      return evelMap[status];
    },
  },
  data() {
    return {
      neijingInfo: {},
      tijianInfo: {},
    };
  },
  created() {
    const query = this.$route.query;
    this.workDetail(query.neijingId);
    this.workDetail(query.tijianId);
  },
  methods: {
    workDetail(id) {
      const params = {
        work_id: id,
      };
      menZhenService.workDetail(params).then((res) => {
        if (res.work_type === "tijian") {
          if (res.tijian_his_booking_time) {
            res.bookingTime = `${moment(res.tijian_his_booking_time).format(
              "YYYY-MM-DD"
            )} ${res.tijian_his_booking_begintime} - ${
              res.tijian_his_booking_endtime
            }`;
          }
          this.tijianInfo = res;
        }
        if (res.work_type === "neijing") {
          if (res.his_booking_time) {
            res.bookingTime = `${moment(res.his_booking_time).format(
              "YYYY-MM-DD"
            )} ${res.his_booking_begintime} - ${res.his_booking_endtime}`;
          }
          this.neijingInfo = res;
        }

        console.log(res);
      });
    },
  },
};
</script>

<style lang="scss">
.appDetails {
  padding: 20px;
  .van-panel {
    margin-bottom: 20px;
  }
}
.appDetails-content {
  padding: 0 15px 10px 15px;
}
</style>